// /app/frontend/src/components/frugal-v2/constants/categories.js
// Category constants for Frugal v2 (80 lines)

// Helper to translate category names using i18next returnObjects
export const translateCategory = (t, category) => {
  if (!category) return '';
  
  // Get all categories as object to bypass key parsing issues with "/" characters
  const categories = t('frugal.categories', { returnObjects: true });
  
  // If we got the object and it has the category, return translation
  if (categories && typeof categories === 'object' && categories[category]) {
    return categories[category];
  }
  
  // Fallback to original category name
  return category;
};

// Income categories (4)
export const INCOME_CATEGORIES = [
  "Salario",
  "Inversiones",
  "Freelance",
  "Otros"
];

// Saving categories (2)
export const SAVING_CATEGORIES = [
  "Ahorro Fondo Emergencia",
  "Ahorro Metas"
];

// Expense categories (25)
export const EXPENSE_CATEGORIES = [
  "Comunicacion",
  "Deudas",
  "Impuestos",
  "Seguros",
  "Vivienda",
  "Educacion",
  "Hogar",
  "Servicios",
  "Vestimenta Necesaria",
  "Alimentacion",
  "Salud",
  "Transporte/Mantenimiento",
  "Caprichos",
  "Entretenimiento",
  "Gastos Hormiga",
  "Mascotas",
  "Ocasionales",
  "Ocio y Vicios",
  "Ocio/Hobbies",
  "Regalos/Donaciones",
  "Restaurante/Bar",
  "Suscripciones",
  "Tarjeta de credito",
  "Cargos Bancarios",
  "Intereses"
];

// Vital categories (affect reserves)
export const VITAL_CATEGORIES = [
  "Alimentacion",
  "Salud",
  "Transporte/Mantenimiento"
];

// Default contingency
export const DEFAULT_CONTINGENCY_PERCENT = 15;
export const MIN_CONTINGENCY_PERCENT = 0;
export const MAX_CONTINGENCY_PERCENT = 50;

export default {
  INCOME_CATEGORIES,
  SAVING_CATEGORIES,
  EXPENSE_CATEGORIES,
  VITAL_CATEGORIES,
  DEFAULT_CONTINGENCY_PERCENT,
  MIN_CONTINGENCY_PERCENT,
  MAX_CONTINGENCY_PERCENT
};
